/*
 * @Description: 128转角柜封板
 * @Author: Dai Guo
 * @Date: 2021-12-27 14:34:41
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-06-07 10:04:40
 */
import MeshManage from '../meshManage';
import { FRAMECATEGORY, FRAMEDEPTH } from '../utils/kitchenConfig';
class CornerCabinetPlate extends MeshManage {
    // meshManage:MeshManage;
    constructor(mesh) {
        super(mesh);
        this.mesh = mesh;
    }
    /**
     * 根据templatejson获取128转角柜的所有模型对象
     * @param templateJson templatejson
     * @returns 转角柜所需补板的对象数组  一个转角柜搭两个补板
     */
    // eslint-disable-next-line class-methods-use-this
    static getCornerCabinetPlateMesh(templateJson) {
        var _a, _b, _c, _d;
        // 跟template耦合 后续更改的话需要变动
        const l1Frame = templateJson.bottom.length1.frames || [];
        const l2Frame = ((_a = templateJson.bottom.length2) === null || _a === void 0 ? void 0 : _a.frames) || [];
        // 最多有两个转角柜 一个在l1  一个在l2  先获取转角柜数组
        const l1Corner = l1Frame.filter((item) => [
            FRAMECATEGORY.CATEGORY_8,
            FRAMECATEGORY.CATEGORY_27,
            FRAMECATEGORY.CATEGORY_28,
        ].includes(item.categoryId) && item.width === 128);
        const l2Corner = l2Frame.filter((item) => [
            FRAMECATEGORY.CATEGORY_8,
            FRAMECATEGORY.CATEGORY_27,
            FRAMECATEGORY.CATEGORY_28,
        ].includes(item.categoryId) && item.width === 128);
        // 当转角柜存在的时候  去除对象里面的sealPlate对象  即为转角柜的补板对象
        const sealPlate = [];
        if (l1Corner.length > 0) {
            (_b = l1Corner[0].sealPlate) === null || _b === void 0 ? void 0 : _b.map((item) => sealPlate.push(Object.assign(Object.assign({}, item), { componentBasic: item })));
        }
        if (l2Corner.length > 0) {
            (_d = (_c = l2Corner[0]) === null || _c === void 0 ? void 0 : _c.sealPlate) === null || _d === void 0 ? void 0 : _d.map((item) => sealPlate.push(Object.assign(Object.assign({}, item), { componentBasic: item })));
        }
        return [sealPlate];
    }
    /**
     * 设置转角柜补板的缩放值
     * @param parent 转角柜对象
     * @param doorFrame 转角柜所在的门板对象
     * @param needRotation 补板是否需要旋转
     */
    setCornerCabinetPlateScale(parent, doorFrame, needRotation) {
        const { x, y, z } = this.getModelSize();
        const parentSize = parent.getModelSize();
        // y、z  无论旋不旋转一样的处理
        this.mesh.scaling.y = parentSize.y / y;
        this.mesh.scaling.z = doorFrame.getModelSize().z / z;
        if (needRotation) {
            // 需要旋转的话就是突出来的8cm部分  长度为柜子的z-深度    y就是转角柜的高度   z改成门板的厚度 这样可以跟门板一齐
            this.mesh.scaling.x = (parentSize.z - FRAMEDEPTH.BOTTOM) / x;
        }
        else {
            // 不需旋转的话就是门板边上的补板   长度为 柜子的x-柜门的宽度-柜体的深度    y为柜子的高 z 为门板的厚度 - doorFrame.getModelSize().z
            this.mesh.scaling.x = (parentSize.x - FRAMEDEPTH.BOTTOM - doorFrame.getModelSize().x) / x;
        }
    }
    /**
     * 设置上面的补板的位置及方向
     * @param parentMesh 转角柜对象
     * @param needRotation 是否需要旋转
     * @param direction 转角柜方向
     * @param doorFrame 转角柜上面的门板对象
     */
    setCornerCabinetPlatePosition(parentMesh, needRotation, direction, doorFrame) {
        // 底柜的框架深度  用来计算伸出来的那个8cm所在的位置
        // 获取转角柜的长宽高
        const { x, z } = parentMesh.getModelSize();
        const parentPosition = parentMesh.mesh.position;
        const position = {
            x: 0,
            y: 0,
            z: 0,
        };
        // 补板的y是固定的 跟转角柜一样
        position.y = parentPosition.y;
        // 根据左右获取转角柜伸出来的那个8cm所在的x
        if (direction === 'left') {
            // 左转角柜
            if (needRotation) {
                // 需旋转
                position.x = -(parentPosition.x - x / 2 + FRAMEDEPTH.BOTTOM + doorFrame.getModelSize().z * 0.5);
                position.z = FRAMEDEPTH.BOTTOM / 2;
                super.addRotation(0, Math.PI / 2, 0);
            }
            else {
                // 不旋转
                position.x = 0;
                position.z = FRAMEDEPTH.BOTTOM + doorFrame.getModelSize().z * 0.5 - z / 2;
            }
        }
        else if (needRotation) {
            // 右转角柜 需旋转
            position.x = parentPosition.x - x / 2 + FRAMEDEPTH.BOTTOM + doorFrame.getModelSize().z * 0.5;
            position.z = FRAMEDEPTH.BOTTOM / 2;
            super.addRotation(0, Math.PI / 2, 0);
        }
        else {
            // 右转角柜 不旋转
            position.x = x - doorFrame.getModelSize().x - FRAMEDEPTH.BOTTOM
                - (x - FRAMEDEPTH.BOTTOM - doorFrame.getModelSize().x) / 2 - doorFrame.getModelSize().z * 2;
            position.z = FRAMEDEPTH.BOTTOM + doorFrame.getModelSize().z * 0.5 - z / 2;
        }
        // 设置门板的位置
        super.setModelPosition(position);
    }
}
export default CornerCabinetPlate;
